import type { InjectionKey } from 'vue';

export type PDPRedesignExperiment = {
	showSizeForm: boolean;
};
export type BrandListingExperiment = {
	variant: 'control' | '1' | '2' | '3';
};

export type PlpVideoIconExperiment = {
	showVideoIcon: boolean;
};

export const PDPRedesignExperimentInjectionKey = Symbol(
	'PDPRedesignExperiment',
) as InjectionKey<Ref<PDPRedesignExperiment | undefined>>;

export const isDeliveryDaysExperimentInjectionKey = Symbol(
	'deliveryDaysExperiment',
) as InjectionKey<Ref<boolean>>;

export const brandListingExperimentInjectionKey = Symbol(
	'BrandListingExperiment',
) as InjectionKey<Ref<BrandListingExperiment | undefined>>;
export const PlpVideoIconExperimentInjectionKey = Symbol(
	'plpVideoIconExperiment',
) as InjectionKey<Ref<PlpVideoIconExperiment | undefined>>;

export const useStatsigExperiment = () => {
	const pdpRedesignExperiment = inject(PDPRedesignExperimentInjectionKey);

	const isDeliveryDaysExperiment = inject(isDeliveryDaysExperimentInjectionKey);
	const brandListingExperiment = inject(brandListingExperimentInjectionKey);
	const plpVideoIconExperiment = inject(PlpVideoIconExperimentInjectionKey);

	return {
		pdpRedesignExperiment,
		isDeliveryDaysExperiment,
		brandListingExperiment,
		plpVideoIconExperiment,
	};
};
